import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(
  (theme) => ({
    voucherReference: {
      height: '50px',

      '& .MuiFilledInput-input': {
        padding: '10px 12px',
        boxSizing: 'border-box',
        height: '50px',
        color: 'blue',
      },
    },
    buttonContainer: {
      minWidth: '140px',
      [theme.breakpoints.down('xs')]: {
        minWidth: '90px',
      },
    },
  }),
  { name: 'VoucherReference' },
);

export default useStyles;
